<template>
    <b-breadcrumb
        class="bg-white mt-1"
        :items="items"
    />
</template>

<script>
export default {
    name: 'BreadcrumbBlock',
    data() {
        return {
            items: [
                {
                    to: '/orders',
                    text: 'Заказы',
                },
                {
                    text: 'Просмотр заказа',
                    active: true,
                },
            ],
        };
    },
};
</script>